// extracted by mini-css-extract-plugin
export default {"button":"Button2_button__vGZ95"};